export class ClientScore {
  ageinMonths: number
  totalScoreComparision: number | null
  totalScoreProfessional: number
  ageString: string

  constructor(data?: any) {
    this.ageinMonths = data?.ageinMonths ?? 0
    this.totalScoreComparision = data?.totalScoreComparision ?? null
    this.totalScoreProfessional = data?.totalScoreProfessional ?? 0
    this.ageString = data?.ageString ?? ''
  }
}
